import React from "react";
import "./TermsConditions.css";

const TermsConditions = () => {
  return (
    <div className="vt-terms-wrapper">
      <div className="vt-terms-container">
        <h1 className="vt-terms-title anim anim-bottom">Terms & Conditions</h1>

        <p>
          Welcome to Vangal Dairies. By accessing and using our website, you agree
          to comply with the following terms and conditions. Please read them
          carefully before proceeding.
        </p>

        <h2>1. Company Information</h2>
        <p>
          Vangal Dairies, established in 1993, operates as a premium dairy products
          manufacturer delivering hygienic, traditional, and preservative-free
          products under the brands VANGAL and GOPIKA.
        </p>

        <h2>2. Use of Website</h2>
        <p>
          You agree to use this website only for lawful purposes. You must not use
          this site in a way that disrupts or affects its functionality or security.
        </p>

        <h2>3. Product Information</h2>
        <p>
          We strive to provide accurate product details, packaging information, and
          images. However, product specifications may vary based on availability and
          production. We reserve the right to update or modify product information
          without prior notice.
        </p>

        <h2>4. Orders & Payments</h2>
        <p>
          Any purchase made through our official channels must comply with our
          ordering policies. Prices are subject to change based on market conditions
          and operational costs.
        </p>

        <h2>5. Intellectual Property</h2>
        <p>
          All content on this website—including images, logos, text, graphics, and
          media—belongs to Vangal Dairies or its associates. Any reproduction or
          misuse without permission is strictly prohibited.
        </p>

        <h2>6. Limitation of Liability</h2>
        <p>
          Vangal Dairies shall not be held liable for any damages arising out of the
          use or inability to use the website, including technical errors,
          interruptions, or inaccuracies in content.
        </p>

        <h2>7. External Links</h2>
        <p>
          Our website may contain links to third-party websites. These are provided
          for convenience only, and we are not responsible for their content or
          policies.
        </p>

        <h2>8. Changes to Terms</h2>
        <p>
          Vangal Dairies reserves the right to update, modify, or revise these terms
          at any time. Continued use of the website indicates your acceptance of
          these changes.
        </p>

        <h2>9. Contact Information</h2>
        <p>
          For any queries related to our Terms & Conditions, you may contact us
          through our official support channels.
        </p>
      </div>
    </div>
  );
};

export default TermsConditions;
